import axios from "axios";
import { BASE_URL } from "../../helper/base-url";
import { LOCATION_OPTIONS } from "../../utils/locations";

export async function fetchLocations() {
  try {
    const res = await axios.get(`${BASE_URL}api/locations`);
    const rows = res?.data?.result?.data;
    if (Array.isArray(rows) && rows.length) return rows;
  } catch {
    /* fallback below */
  }
  return LOCATION_OPTIONS.map((loc) => ({
    value: `${loc.city}, ${loc.country}`,
    label: `${loc.city}, ${loc.country}`,
    city: loc.city,
    country: loc.country,
    lat: loc.lat,
    lng: loc.lng,
  }));
}
